import React, { useEffect } from 'react';

import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import LoaderStep from 'pages/CuroPages/ApplicationProcess/steps/LoaderStep';
import { runPreliminaryCheck } from 'thunks';

const ApplicationPreliminaryCheckStep = () => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const handleRunPreliminaryCheck = async () => {
    await dispatchWithUnwrap(runPreliminaryCheck());
  };

  useEffect(() => {
    handleRunPreliminaryCheck();
  }, []);

  return <LoaderStep />;
};

export default ApplicationPreliminaryCheckStep;
